/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeriesAttributeWithSourceDTO } from './SeriesAttributeWithSourceDTO';
import {
    SeriesAttributeWithSourceDTOFromJSON,
    SeriesAttributeWithSourceDTOFromJSONTyped,
    SeriesAttributeWithSourceDTOToJSON,
} from './SeriesAttributeWithSourceDTO';

/**
 * 
 * @export
 * @interface SeriesPointSourceResponseDTO
 */
export interface SeriesPointSourceResponseDTO {
    /**
     * 
     * @type {Array<SeriesAttributeWithSourceDTO>}
     * @memberof SeriesPointSourceResponseDTO
     */
    attributes: Array<SeriesAttributeWithSourceDTO>;
}

/**
 * Check if a given object implements the SeriesPointSourceResponseDTO interface.
 */
export function instanceOfSeriesPointSourceResponseDTO(value: object): value is SeriesPointSourceResponseDTO {
    if (!('attributes' in value) || value['attributes'] === undefined) return false;
    return true;
}

export function SeriesPointSourceResponseDTOFromJSON(json: any): SeriesPointSourceResponseDTO {
    return SeriesPointSourceResponseDTOFromJSONTyped(json, false);
}

export function SeriesPointSourceResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesPointSourceResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributes': ((json['attributes'] as Array<any>).map(SeriesAttributeWithSourceDTOFromJSON)),
    };
}

export function SeriesPointSourceResponseDTOToJSON(value?: SeriesPointSourceResponseDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributes': ((value['attributes'] as Array<any>).map(SeriesAttributeWithSourceDTOToJSON)),
    };
}

